import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

/* English translation files */
import cartEn from "./lang/en/Cart.json";
import headerEn from "./lang/en/Header.json";
import homeEn from "./lang/en/Home.json";
import ordersEn from "./lang/en/Orders.json";
import sidebarEn from "./lang/en/Sidebar.json";
import zonesEn from "./lang/en/Zones.json";

/* Arabic translation files */
import cartAr from "./lang/ar/Cart.json";
import headerAr from "./lang/ar/Header.json";
import homeAr from "./lang/ar/Home.json";
import ordersAr from "./lang/ar/Orders.json";
import sidebarAr from "./lang/ar/Sidebar.json";
import zonesAr from "./lang/ar/Zones.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: {
          ...cartEn,
          ...headerEn,
          ...homeEn,
          ...ordersEn,
          ...sidebarEn,
          ...zonesEn,
        },
      },
      ar: {
        translations: {
          ...cartAr,
          ...headerAr,
          ...homeAr,
          ...ordersAr,
          ...sidebarAr,
          ...zonesAr,
        },
      },
    },
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",
    ns: ["translations"],
    defaultNS: "translations",
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
